import { render, staticRenderFns } from "./MultiManuscriptEditorPage.vue?vue&type=template&id=0c388a6d&scoped=true&"
import script from "./MultiManuscriptEditorPage.vue?vue&type=script&lang=ts&"
export * from "./MultiManuscriptEditorPage.vue?vue&type=script&lang=ts&"
import style0 from "./MultiManuscriptEditorPage.vue?vue&type=style&index=0&id=0c388a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c388a6d",
  null
  
)

export default component.exports